import { ProgressCallback } from "shared/controllers/UserDataManager";
import { TNotificationCallback, TNotificationType } from "./Notification";

export enum RenderType {
    None = -1,
    VirtualTour = 0,
    Still = 1,
    Thumbnail = 2,
    Video = 3,
    Lighting = 4
}

export enum TRenderStatus {
    // Norma Backend
    Created = 0,
    Uploaded = 1,
    Converted = 2,
    Queued = 3,
    // Rendering Service
    Received = 100,
    Rendering = 101,
    Uploading = 102,
    DownloadingNormaJson = 103,
    DownloadingUsdz = 104,
    LoadingLevel = 105,
    SceneSetup = 106,
    Exposure = 107,
    Stitching = 108,
    Canceled = 352,
    Interrupted = 353,
    Finished = 354,
    // Calculated
    Timeout = 1023,
    Failed = 1024,
    // Placeholder
    Placeholder = -1,
}

export enum RenderJobStatus {
    Unavailable = -1,
    None = 0,
    Success = 1,
    Error = 2
}

export default interface RenderJob {
    data: {
        id?: number;
        created_at?: string;
        camera_count?: number;
    };
    getProgress(): number;
    getCreatedAt() : Date;
    notify(type: TNotificationType, callback?: TNotificationCallback): void;
    upload(file: XMLHttpRequestBodyInit, progress_handler?: ProgressCallback): Promise<unknown>;
    isTerminal(): boolean;
    isFailed(): boolean;
    isCanceled(): boolean;
    isCompleted(): boolean;
    isPlaceholder(): boolean;
    isCancellable(): boolean;
    cancel(): Promise<RenderJob>;
}
